import { render, staticRenderFns } from "./TreeViewItem.vue?vue&type=template&id=72cf700a"
import script from "./TreeViewItem.vue?vue&type=script&lang=js"
export * from "./TreeViewItem.vue?vue&type=script&lang=js"
import style0 from "./TreeViewItem.vue?vue&type=style&index=0&id=72cf700a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports